<template>
  <div class="w-100">
    <p class="mb-0 heading-6-1">Choose payment time</p>
    <p class="mb-3 body-2-2-1">Please select a time to pay for your order</p>
    <div 
      class="w-100 p-3 rounded-6 mb-3 cursor-pointer position-relative" 
      v-for="p_mode in payment_mode.list" 
      @click="selectPaymentMode(p_mode)"
        :class="p_mode.id == payment_mode.selected.id ? 'border-green' : 'border-semi-grey'">
      <div class="row no-gutters z-index-1029 position-relative">
        <div class="col-10 align-self-center">
          <p class="mb-0 " :class="p_mode.id == payment_mode.selected.id ? 'body-1-4' : 'body-1-2'">{{p_mode.title}}</p>
          <p class="mb-0 body-2-2-1">{{p_mode.description}}</p>
        </div>
        <div class="col-2">
          <div class="dimention-24 rounded-circle ml-auto" :class="p_mode.id == payment_mode.selected.id ? 'custom-radio-active' : 'border-semi-grey-3'">
          </div>
        </div>
      </div>
      <div v-if="p_mode.id == payment_mode.selected.id" class="z-index-1028 position-absolute w-100 h-100 bg-green radius-12" style="top:0;left:0;opacity:0.07"></div>
    </div>
    <p v-if="payment_mode.error != ''" class="mb-0 body-3-3-1 text-danger"><i class="simple-icon-exclamation mr-1"></i> {{payment_mode.error}}</p>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        is_load: true,
        error: '',
        payment_mode:{
        	list:[
            {
              id: 'PAY_LATER',
              title: 'Pay Later',
              description: 'You can make payment when you arrive at the hotel.'
            },
            {
              id: 'PAY_IMMEDIATELY',
              title: 'Pay Now',
              description: 'You must complete the payment to proceed with the order'
            }
          ],
        	selected:{},
        	error: ''
        }
      }
    },
    methods: {
      selectPaymentMode(p_mode=null){
      	this.payment_mode.selected = p_mode == null ? {} : p_mode
        this.$emit('getSelectedOption',p_mode)
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/hotel/concierge/transaction/PaymentOption.vue